var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompletedOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_check-circle_24px",
    "data-name": "icon/check-circle_24px",
    transform: "translate(0.397 0.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-circle",
    transform: "translate(4.6 4.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(0.002 0.002)",
    fill: "rgba(59,176,255,0.2)",
    stroke: "#3bb0ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(10.706 14.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check-2",
    d: "M33.036,9.257,16.131,26.166,8.447,18.479",
    transform: "translate(-8.447 -9.257)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Boundry",
    width: 56,
    height: 56,
    transform: "translate(-0.397 -0.397)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedOrder);
export default __webpack_public_path__ + "static/media/completed_order.0f9abf86dd7e5099b2192d6cf69becf0.svg";
export { ForwardRef as ReactComponent };